import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const BoxStyles = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  minHeight: '56px',
  backgroundColor: theme.palette.background.blue.light
});

export const ScanContainerStyle = ({ theme }) => ({
  width: '41px',
  height: '41px',
  backgroundColor: theme.palette.fixed.black,
  marginLeft: '40px',
  alignItems: 'center',
  cursor: 'zoom-in',
  flex: 'none'
});

export const QRCodeContainerStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  padding: '10px',
  maxWidth: '400px',
  alignItems: 'center',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
});

export const BoxStyled = styled(Stack)(BoxStyles);
export const ScanContainerStyled = styled(Box)(ScanContainerStyle);
export const QRCodeContainerStyled = styled(Box)(QRCodeContainerStyle);
